export function modalContactEventPush(wpcfModalSelector, action, label, customProductName, content = false) {
    let eventData = JSON.parse(sessionStorage.getItem(wpcfModalSelector));
    let eventItems, eventLabel, eventContent, eventPosition, eventContext, customFormName;

    if (eventData) {
        eventItems = eventData['events-form'];
    }

    if (eventItems) {
        eventLabel = eventItems['eventLabel'];
        eventContent = eventItems['eventContent'];
        eventPosition = eventItems['eventPosition'];
        eventContext = eventItems['eventContext'];
        customFormName = eventItems['customFormName'];
    }
    
    if (customProductName) {
      eventPosition = customProductName;
    }
    
    let dataOld = {
        'event': 'EOSCOM',
        'eventCategory': 'EosComEvents',
        'eventAction': action==='Success' ? 'Contact Form Success Submit' : `Contact Form ${action}`,
        'eventLabel': label,
        'eventContent': content ? content : ''
    }


    let data = {
        'event' : 'EOSCOM', 
        'eventCategory' : 'EosComEvents', 
        'eventAction': customFormName ? `${customFormName}_form_${action.toLowerCase()}` : `demo_form_${action.toLowerCase()}`,
        'eventLabel': eventLabel ? eventLabel : '', 
        'eventContent': eventContent ? eventContent : '',
        'eventPosition': eventPosition ? eventPosition : '',
        'eventContext': eventContext ? eventContext : ''
    }
    dataLayer.push(data);

    if (action !=='submit') {
        dataLayer.push(dataOld);
    }
}

export function modalBlogEventPush(action, label) {
    let data = {
        'event': 'EOSCOM',
        'eventCategory': 'EosComEvents',
        'eventAction': action,
        'eventLabel': label
    }
    dataLayer.push(data);
}

export function modalBlogNewEventPush(action, label, context) {
    let data = {
        'event': 'EOSCOM',
        'eventCategory': 'EosComEvents',
        'eventAction': action,
        'eventLabel': label,
        'eventContent': '',
        'eventPosition': '',
        'eventContext': context ? context : ''
        
    }
    dataLayer.push(data);
}